import createIdleScrollListener from "../utils/createIdleScrollListener";

let prevOffset = 0;

function toggleFloatingElement(element) {
    const { offset } = element.dataset;
    if (window.scrollY > parseInt(offset, 10) && window.scrollY > prevOffset) {
        element.classList.add("active");
    } else {
        element.classList.remove("active");
    }
    prevOffset = window.scrollY;
}

function toggleFloatingElements(floatingElements) {
    return createIdleScrollListener(() => {
        floatingElements.forEach(toggleFloatingElement);
    });
}

export default function floatingElements(floatingElements) {
    document.addEventListener("scroll", toggleFloatingElements(floatingElements), {
        passive: true,
    });
}
